// extracted by mini-css-extract-plugin
module.exports = {"root":"token-picker_root__3Mbrf"};